import request from '@/axios'


//http://localhost:8000/api/
export function getAllCourse (customer_id, quaryParams, payload = null) {
  return request({
    url: `/V1/ClientUser/course/list/${customer_id}?page=${quaryParams}`,
    method: 'POST',
    data:payload
  })
}
// http://localhost:8000/api/ClientUser/course/list


export function getMyCourse (customer_id, quaryParams, client_user_id, payload) {
  return request({
    url: `/V1/ClientUser/course/my-list/${customer_id}/${client_user_id}?page=${quaryParams}`,
    method: 'POST',
    data:payload
  })
}

// http://localhost:8000/api/ClientUser/course/my-list/171

export function getCourseDetail (client_user_id, course_slug) {
  return request({
    url: `/ClientUser/course/detail/${client_user_id}/${course_slug}`,
    method: 'POST'
  })
}


export function enrollCourse (payload) {
  return request({
    url: '/ClientUser/course/enroll',
    method: 'POST',
    data:payload
  })
}


export function markComplete (payload) {
  return request({
    url: '/ClientUser/course/mark-complete',
    method: 'POST',
    data:payload
  })
}

export function fetchComplete (customer_id, course_id) {
  return request({
    url: `/V1/ClientUser/course/content/status/${customer_id}/${course_id}`,
    method: 'POST'
  })
}


export function getRepoId (customer_id, payload) {
  return request({
    url:`ClientUser/repository-detail/${customer_id}`,
    method:'POST',
    data:payload
  })
}


export function getUploadedFilesId (payload) {
  return request({
    url:'ClientUser/file/add',
    method:'POST',
    data:payload,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


// http://localhost:8000/api/
// {
//     "course_id": 56,
//     "lesson_id" :68,
//     "topic_id":2,
//     "type":1/2/3 course-1, lesson-2, lesson-3
// }

// http://localhost:8000/api/ClientUser/course/enroll
// {
// "course_id": 56,
// "platform_customer_id": 2
// }
//POST-http://localhost:8000/api/ClientUser/course/detail/171/Cours-122

// http://localhost:8000/api/ClientUser/course/submit-answer
// {
// "course_id": "",
// "lesson_id": 122,
// "topic_id": "",
// "type":1/23,
// "assignment_question_id" : 121,
// "assignment_question_answer_id": 173,
// "question_type": 1/2 //1=for assignment,2=for question bank
// }

export function SubmitAnswer (payload) {

  return request({
    url: '/ClientUser/course/submit-answer',
    method: 'POST',
    data:payload
  })

}

export function getTimingsApi (payload) {
  return request({
    url:'/ClientUser/schedule/timing/one-2-one',
    method:'POST',
    data: payload
  })
}


export function getChildList () {
  return request({
    url:'/ClientUser/get_child_list',
    method:'GET'
  })
}

// Request URL: http://scoolio-backend-dev.track-progress.com/api/ClientUser/course/my-list/short/349?page=1


export function getShortCourseListApi (userId, payload) {
  return request({
    url:`ClientUser/course/my-list/short/${userId}`,
    method:'POST',
    data:payload
  })
}

export function shareCourseToChild (customer_id, payload) {
  return request({
    url:`ClientUser/course/share_to_child/${customer_id}`,
    method:'POST',
    data:payload
  })

}

export function courseAllocateChildListApi (customer_id) {
  return request({
    url:`ClientUser/course/fetch_to_child/${customer_id}`,
    method:'POST'
  })

}
export function getSubjectList (customer_id, page = 1) {
  return request({
    url:`/ClientUser/course/subjects/list/${customer_id}?page=${page}`,
    method:'POST'
  })
}

export function getAvailableDay (payload) {
  return request({
    url:'ClientUser/course/reschedule/get_available_days',
    method:'POST',
    data:payload
  })
}

export function getAssignmentBuilderId (customer_id, course_id, payload) {
  return request({
    url:`V1/ClientUser/course/assignment/details/${customer_id}/${course_id}`,
    method:'POST',
    data:payload
  })
}

// /ClientUser/get_child_list =>get

// http://localhost:8000/api/ClientUser/schedule/timing/one-2-one

// {
// "course_id": 331,
// "schedule_date": "2021-02-22",
// "teacher_id": "121"
// }

export function getCourseDetailsView (customer_id, course_id) {
  return request({
    url:`V1/ClientUser/course/details/courseContent/${customer_id}/${course_id}`,
    method:'GET'
  })
}